/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Sovereign_CtaInputs */

const en_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Sovereign`)
};

const es_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasar a Sovereign`)
};

const fr_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passer à Sovereign`)
};

const de_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zu Sovereign wechseln`)
};

const ja_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereignへ移行`)
};

const zh_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`升级至 Sovereign`)
};

const ar_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انتقل إلى Sovereign`)
};

const id_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jadi Sovereign`)
};

const it_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa a Sovereign`)
};

const ru_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти на Sovereign`)
};

const pt_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seja Sovereign`)
};

const ko_pricing_sovereign_cta = /** @type {(inputs: Pricing_Sovereign_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign으로 전환`)
};

/**
* | output |
* | --- |
* | "Go Sovereign" |
*
* @param {Pricing_Sovereign_CtaInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_sovereign_cta = /** @type {((inputs?: Pricing_Sovereign_CtaInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Sovereign_CtaInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_sovereign_cta(inputs)
	if (locale === "es") return es_pricing_sovereign_cta(inputs)
	if (locale === "fr") return fr_pricing_sovereign_cta(inputs)
	if (locale === "de") return de_pricing_sovereign_cta(inputs)
	if (locale === "ja") return ja_pricing_sovereign_cta(inputs)
	if (locale === "zh") return zh_pricing_sovereign_cta(inputs)
	if (locale === "ar") return ar_pricing_sovereign_cta(inputs)
	if (locale === "id") return id_pricing_sovereign_cta(inputs)
	if (locale === "it") return it_pricing_sovereign_cta(inputs)
	if (locale === "ru") return ru_pricing_sovereign_cta(inputs)
	if (locale === "pt") return pt_pricing_sovereign_cta(inputs)
	return ko_pricing_sovereign_cta(inputs)
});